<template src="./template.html"></template>

<script>
  export default {
    name: 'TopicFormOverlay',
    props: {
      isOpen: Boolean,
      createTopic: Boolean,
      group: Object,
    },
    data() {
      return {
        name: '',
        description: '',
      }
    },
    computed: {
      opened: {
        set() {
          this.$emit('onCloseOverlay')
        },
        get() {
          return this.isOpen
        },
      },
      type() {
        return this.createTopic ? 'create' : 'suggestion'
      },
    },
    methods: {
      onSubmit() {
        this.$emit('submit', {
          name: this.name,
          description: this.description,
          type: this.type,
        })
      },
    },
  }
</script>
